document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-menu]');
  const nav = document.querySelector('[data-nav]');

  menu?.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    menu.setAttribute('aria-expanded', String(open));
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const section = gallery.closest('[data-product-section]');
    const stage = gallery.querySelector('.ps-gallery__stage');
    const slides = [...gallery.querySelectorAll('[data-product-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-current]');
    const variant = section?.querySelector('[data-variant-select]');
    const price = section?.querySelector('[data-product-price]');
    const add = section?.querySelector('[data-add-to-cart]');

    let current = 0;
    let touchStartX = null;
    let touchStartY = null;

    const show = (index) => {
      if (!slides.length) return;

      current = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const active = i === current;

        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === current);
      });

      if (counter) {
        counter.textContent = String(current + 1);
      }
    };

    /* LEFT AND RIGHT ARROWS */
    previous?.addEventListener('click', () => {
      show(current - 1);
    });

    next?.addEventListener('click', () => {
      show(current + 1);
    });

    /* THUMBNAIL BUTTONS */
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        show(Number(thumb.dataset.slideIndex));
      });
    });

    /* MOBILE SWIPE */
    stage?.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;

        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );

    stage?.addEventListener(
      'touchend',
      (event) => {
        if (
          touchStartX === null ||
          touchStartY === null ||
          event.changedTouches.length !== 1
        ) {
          return;
        }

        const touchEndX = event.changedTouches[0].clientX;
        const touchEndY = event.changedTouches[0].clientY;

        const distanceX = touchEndX - touchStartX;
        const distanceY = touchEndY - touchStartY;

        const horizontalSwipe =
          Math.abs(distanceX) > 40 &&
          Math.abs(distanceX) > Math.abs(distanceY);

        if (horizontalSwipe) {
          if (distanceX < 0) {
            show(current + 1);
          } else {
            show(current - 1);
          }
        }

        touchStartX = null;
        touchStartY = null;
      },
      { passive: true }
    );

    /* PRODUCT COLOR OR VARIANT CHANGE */
    variant?.addEventListener('change', (event) => {
      const option = event.target.options[event.target.selectedIndex];

      if (price && option.dataset.price) {
        price.textContent = option.dataset.price;
      }

      if (add) {
        const available = option.dataset.available === 'true';

        add.disabled = !available;
        add.textContent = available ? 'Add to bag' : 'Sold out';
      }

      if (option.dataset.mediaId) {
        const index = slides.findIndex(
          (slide) => slide.dataset.mediaId === option.dataset.mediaId
        );

        if (index >= 0) {
          show(index);
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });

    show(0);
  });
});